import { Controller } from "@hotwired/stimulus"

// Keeps a chat message list scrolled to the latest entry (initial load + Turbo Stream appends).
export default class extends Controller {
  connect() {
    this.scrollToBottom({ smooth: false })

    this.observer = new MutationObserver(() => this.scheduleScroll())
    this.observer.observe(this.element, { childList: true })

    this.onStreamRender = (event) => {
      const stream = event.target
      if (stream?.getAttribute?.("target") === this.element.id) {
        this.scheduleScroll()
      }
    }
    document.addEventListener("turbo:before-stream-render", this.onStreamRender)
  }

  disconnect() {
    this.observer?.disconnect()
    document.removeEventListener("turbo:before-stream-render", this.onStreamRender)
    if (this.scrollTimer) window.clearTimeout(this.scrollTimer)
  }

  scheduleScroll() {
    // After Turbo appends, layout may settle one frame later.
    this.scrollToBottom({ smooth: true })
    if (this.scrollTimer) window.clearTimeout(this.scrollTimer)
    this.scrollTimer = window.setTimeout(() => this.scrollToBottom({ smooth: false }), 50)
  }

  scrollToBottom({ smooth = true } = {}) {
    requestAnimationFrame(() => {
      const top = this.element.scrollHeight
      if (typeof this.element.scrollTo === "function") {
        this.element.scrollTo({ top, behavior: smooth ? "smooth" : "auto" })
      } else {
        this.element.scrollTop = top
      }
    })
  }
}
